<template>
  <div class="vip-detail-address">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="vipDetailAddressInfos.addresses" border style="width: 100%" v-loading="loading">
        <el-table-column prop="userName" :label="$t('vipDetailAddress.receiver')" align="center"
         ></el-table-column>
        <el-table-column prop="tel" :label="$t('vipDetailAddress.receiverPhone')" align="center"
          width="120"></el-table-column>
        <el-table-column prop="address" :label="$t('vipDetailAddress.receiverAddress')" align="center"
          ></el-table-column>
        <el-table-column :label="$t('vipDetailAddress.isDefault')" align="center" >
          <template #default="{ row }">
            {{ row.isDefault === 'T' ? $t('common.yes') : $t('common.no') }}
          </template>
        </el-table-column>
        <el-table-column prop="postalCode" :label="$t('vipDetailAddress.postalCode')" align="center"
          ></el-table-column>
        <el-table-column prop="createTime" :label="$t('vipDetailAddress.createTime')" align="center"
          ></el-table-column>
      </el-table>

      <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { queryShopUserAddress } from '@/api/user/vipDetailApi'

export default {
  name: 'VipDetailAddress',
  data() {
    return {
      vipDetailAddressInfos: {
        addresses: [],
        tel: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(data) {
      this.vipDetailAddressInfos.tel = data.tel
      this.loadAddressData()
    },
    loadAddressData() {
      if (!this.vipDetailAddressInfos.tel) return

      this.loading = true
      const params = {
        tel: this.vipDetailAddressInfos.tel,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      queryShopUserAddress(params)
        .then(res => {
          this.vipDetailAddressInfos.addresses = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取地址数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadAddressData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadAddressData()
    }
  }
}
</script>

<style scoped>
.vip-detail-address {
  padding: 20px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>